import styled from "@emotion/styled";
import { Box, BoxProps } from "@mui/material";

export const DisclaimerCard: React.FC<BoxProps> = styled(Box)`
  border: ${(p) => p.theme.colors.border} solid 1px;
  padding: 1.5rem;
  border-radius: 1rem;
`;
